import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';

type ActivityErrorStateProps = {
    error: string;
};

export const ActivityErrorState = ({ error }: ActivityErrorStateProps) => {
    return (
        <Box sx={{ padding: '20px' }}>
            <Text>Error loading activity: {error}</Text>
        </Box>
    );
}; 